import {Product} from "@/lib/keys";

export function product_has_property(product: Product, property: string) {
  return product.properties && product.properties[property];
}

export function get_product_property(product: Product, property: string) {
  if (!product_has_property(product, property)) {
    return null;
  }

  return product.properties[property];
}

export function build_product_description(product: Product): DescriptionObjectPart[] {
  const parts = [];
  parts.push(get_product_description_part(product, 'property.nicotine_per_portion'));
  parts.push(get_product_description_part(product, 'property.nicotine_percentage'));
  parts.push(get_product_description_part(product, 'property.type_portion'));
  parts.push(get_product_description_part(product, 'property.taste'));
  parts.push(get_product_description_part(product, 'property.pouches_in_can'));
  parts.push(get_product_description_part(product, 'property.strength'));

  return parts
    .filter(p => p[2] !== null && p[2].length >= 1)
    .sort((a, b) => a[1] === b[1] ? 0 : a[1] < b[1] ? 1 : -1)
    .map(part => ({
      property: part[0],
      priority: part[1],
      text: part[2],
    }) as DescriptionObjectPart);
}

type DescriptionPart = [string, number, string | null];

interface DescriptionObjectPart {
  property: string;
  priority: number;
  text: string;
}

export function get_product_description_part(product: Product, part: string): DescriptionPart {
  if (product_has_property(product, part)) {
    return [
      part,
      get_product_property_priority(part),
      get_product_property_description_text(product, part)
    ] as DescriptionPart;
  }
  return [part, -1, null];
}

export function get_product_property_priority(part: string) {
  let priority = -1;
  switch (part.replace('property.', '').toLowerCase()) {
    case 'nicotine_per_portion':
    case 'nicotine_percentage':
      priority = 5;
      break;
    case 'type_portion':
      priority = 10;
      break;
    case 'strength':
      priority = 3;
      break;
    case  'taste':
      priority = 9;
      break;
    case 'pouches_in_can':
      priority = 1;
      break;
  }

  return priority;
}

export function get_product_property_description_text(product: Product, part: string) {
  let text = '';
  switch (part.replace('property.', '').toLowerCase()) {
    case 'nicotine_per_portion':
      text = `Nikotininnholdet er på ${get_product_property(product, part)} per porsjon.`;
      break;
    case 'type_portion':
      text = `${product.name} er av typen ${get_product_property(product, part)}.`;
      break;
    case 'strength':
      text = `Styrken er på ${get_product_property(product, part)}/5 og kan og refereres til som S${get_product_property(product, part)}.`;
      break;
    case  'taste':
      text = `${product.name} smaker ${get_product_property(product, part)}.`;
      break;
    case 'pouches_in_can':
      text = `Hver boks inneholder ${get_product_property(product, part)}.`;
      break;
  }

  return text;
}
